 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781455522866_COVER from '@/components/9781455522866_cover'
 import LOVE_1 from '@/components/love_1'
 import A781455522866_BOOKTITLEPAGE from '@/components/9781455522866_booktitlepage'
 import A781455522866_BRIEFTOC from '@/components/9781455522866_brieftoc'
 import A781455522866_DEDICATION from '@/components/9781455522866_dedication'
 import A781455522866_ACKNOWLEDGMENTS from '@/components/9781455522866_acknowledgments'
 import A781455522866_CHAPTER_01 from '@/components/9781455522866_chapter_01'
 import A781455522866_CHAPTER_02 from '@/components/9781455522866_chapter_02'
 import A781455522866_CHAPTER_03 from '@/components/9781455522866_chapter_03'
 import A781455522866_CHAPTER_04 from '@/components/9781455522866_chapter_04'
 import A781455522866_CHAPTER_05 from '@/components/9781455522866_chapter_05'
 import A781455522866_CHAPTER_06 from '@/components/9781455522866_chapter_06'
 import A781455522866_CHAPTER_07 from '@/components/9781455522866_chapter_07'
 import A781455522866_CHAPTER_08 from '@/components/9781455522866_chapter_08'
 import A781455522866_CHAPTER_09 from '@/components/9781455522866_chapter_09'
 import A781455522866_CHAPTER_10 from '@/components/9781455522866_chapter_10'
 import A781455522866_CHAPTER_11 from '@/components/9781455522866_chapter_11'
 import A781455522866_CHAPTER_12 from '@/components/9781455522866_chapter_12'
 import A781455522866_CHAPTER_13 from '@/components/9781455522866_chapter_13'
 import A781455522866_CHAPTER_14 from '@/components/9781455522866_chapter_14'
 import A781455522866_CHAPTER_15 from '@/components/9781455522866_chapter_15'
 import A781455522866_CHAPTER_16 from '@/components/9781455522866_chapter_16'
 import A781455522866_CHAPTER_17 from '@/components/9781455522866_chapter_17'
 import A781455522866_CHAPTER_18 from '@/components/9781455522866_chapter_18'
 import A781455522866_CHAPTER_19 from '@/components/9781455522866_chapter_19'
 import A781455522866_CHAPTER_20 from '@/components/9781455522866_chapter_20'
 import LOVE_2 from '@/components/love_2'
 import A781455522866_OPENER from '@/components/9781455522866_opener'
 import A781455522866_TEASER from '@/components/9781455522866_teaser'
 import A781455522866_APPENDIX from '@/components/9781455522866_appendix'
 import A781455522866_CARDPAGE from '@/components/9781455522866_cardpage'
 import A781455522866_FRONTSALES from '@/components/9781455522866_frontsales'
 import A781455522866_APPENDIX_02 from '@/components/9781455522866_appendix_02'
 import A781455522866_TABLEOFCONTENTS from '@/components/9781455522866_tableofcontents'
 import A781455522866_COPYRIGHT from '@/components/9781455522866_copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781455522866_cover",
 			"name" : "9781455522866_cover",
 			"component" : A781455522866_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/9781455522866_booktitlepage",
 			"name" : "9781455522866_booktitlepage",
 			"component" : A781455522866_BOOKTITLEPAGE
 		},
 		{
 			"path" : "/9781455522866_brieftoc",
 			"name" : "9781455522866_brieftoc",
 			"component" : A781455522866_BRIEFTOC
 		},
 		{
 			"path" : "/9781455522866_dedication",
 			"name" : "9781455522866_dedication",
 			"component" : A781455522866_DEDICATION
 		},
 		{
 			"path" : "/9781455522866_acknowledgments",
 			"name" : "9781455522866_acknowledgments",
 			"component" : A781455522866_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/9781455522866_chapter_01",
 			"name" : "9781455522866_chapter_01",
 			"component" : A781455522866_CHAPTER_01
 		},
 		{
 			"path" : "/9781455522866_chapter_02",
 			"name" : "9781455522866_chapter_02",
 			"component" : A781455522866_CHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js